import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "placeholder"];
import React from 'react';
import { FormattedInput } from '../FormattedInput/FormattedInput';

/**
 * `InputMoney` provides mobile users with the appropriate keyboard for easy data entry.
 */
export var InputMoney = function InputMoney(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? 'Money' : _ref$label,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '$' : _ref$placeholder,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(FormattedInput, _extends({
    "data-currency": "InputMoney",
    label: label,
    placeholder: placeholder // By default we always add a
    // comma to indicate the thousands place
    ,
    thousandSeparator: true
  }, otherProps, {
    prefix: "$" // Used to restrict what's available
    // to mobile users via keyboard. We
    // don't use the pattern attribute
    // as that will trigger validation in some
    // browsers like Firefox. Note that
    // this doesn't permit users to enter
    // characters like commas.
    ,
    type: "tel"
  }));
};